/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/291' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `PUT /api/station/unbinding-device`
 */
export interface StationUnbindingDevicePutRequest {
  /**
   * 设备id
   */
  deviceId: string;
}

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `PUT /api/station/unbinding-device`
 */
export type StationUnbindingDevicePutResponse = boolean;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `PUT /api/station/unbinding-device`
 */
type ApiStationUnbindingDevicePutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/291',
    '',
    'http://127.0.0.1',
    '/api/station/unbinding-device',
    'retdata',
    string,
    'deviceId',
    false
  >
>;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `PUT /api/station/unbinding-device`
 */
const apiStationUnbindingDevicePutRequestConfig: ApiStationUnbindingDevicePutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/station/unbinding-device',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['deviceId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiStationUnbindingDevicePut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `PUT /api/station/unbinding-device`
 */
export const apiStationUnbindingDevicePut = /*#__PURE__*/ (
  requestData: StationUnbindingDevicePutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<StationUnbindingDevicePutResponse>(
    prepare(apiStationUnbindingDevicePutRequestConfig, requestData),
    ...args,
  );
};

apiStationUnbindingDevicePut.requestConfig = apiStationUnbindingDevicePutRequestConfig;

/* prettier-ignore-end */
